import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
function initials(author: string): string {
  return author.charAt(0).toUpperCase();
}
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-paper py-12 sm:py-14" aria-labelledby="testimonials-heading" data-id="element-203" data-mp="1mz949hkd4eh0">
      <div className="mx-auto max-w-6xl px-6" data-id="element-204" data-mp="1r02s6axt1t9w">
        <div className="mx-auto max-w-2xl text-center" data-id="element-205" data-mp="1d24e76nebyux">
          <p className="eyebrow text-green-deep" data-id="element-206" data-mp="1d0jllmkn6pzp">En el patio</p>
          <h2 id="testimonials-heading" className="mt-4 font-display text-[1.9rem] font-bold leading-[1.12] text-ink sm:text-[2.3rem]" data-id="element-207" data-mp="1i17iupzgs32d">
            Lo que dicen los docentes argentinos
          </h2>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-208" data-mp="183jf5ajvrl82">
          {testimonials.map(testimonial => <li key={testimonial.author} className="flex h-full flex-col rounded-3xl border border-line bg-shell p-6 shadow-soft" data-id="element-209" data-mp="2yfpbwopodqtb">
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-210" data-mp="32ega6z5vnei0">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-211" data-mp="2q1g9csmw952w" data-mpi={index} />)}
              </div>

              <blockquote className="mt-4 font-sans text-[0.9rem] leading-relaxed text-ink" data-id="element-212" data-mp="34qum8apoi4n1">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-6" data-id="element-213" data-mp="2c26txv6iiezz">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-green/20 bg-green-soft font-display text-base font-bold text-green-deep" aria-hidden="true" data-id="element-214" data-mp="273n5no4g4r4g">
                  {initials(testimonial.author)}
                </span>
                <span className="font-sans text-sm" data-id="element-215" data-mp="2h0i64cka51ld">
                  <span className="block font-semibold text-ink" data-id="element-216" data-mp="19vx3m7drq1p">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-muted" data-id="element-217" data-mp="3sggfkhjddpn4">
                    {testimonial.role} · {testimonial.location}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}